// extracted by mini-css-extract-plugin
export default {"body":"ReportSection_body__r3qWY","p":"ReportSection_p__Z4SZn","wide":"ReportSection_wide__0Vq3c"};